import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  root: {
    margin: '20px 0',
  },
  addressToggle: {
    alignItems: 'flex-start',
    marginBottom: '10px',
    // Make sure the top of the checkbox is aligned with the top of the text on small
    // layouts when the text wraps, but is centered vertically with the text when the
    // text does not wrap:
    '& .MuiButtonBase-root': {
      paddingBottom: 0,
      paddingTop: 0,
    },
    '& .MuiTypography-body1': {
      color: '#696969',
    },
  },
})
